module.exports = __webpack_public_path__ + "static/13-3faf803e4c380b434fc65fbcc021ead5.jpeg";